import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import Stream from './Stream';
import AddStream from './AddStream';
import ViewStream from './ViewStream';
import EditStream from './EditStream';

const ProtectedRoute = ({ element, permission, fallbackPath = '/' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate("/dashboard/stream", { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainStream = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.master || {}; // Only using 'master' permissions

  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
        <Route path='/' element={<Stream />} />

        <Route 
          path='/add-stream' 
          element={<ProtectedRoute element={<AddStream />} permission={Permission.create} fallbackPath="/" />}
        />

        <Route 
          path='/view-stream' 
          element={<ProtectedRoute element={<ViewStream />} permission={Permission.read} fallbackPath="/" />}
        />

        <Route 
          path='/edit-stream' 
          element={<ProtectedRoute element={<EditStream />} permission={Permission.update} fallbackPath="/" />}
        />
      </Routes>
    </div>
  );
};

export default MainStream;
